import { kilometersToMiles, LengthUnit } from "components/format/Length/Length"
import { kilogramsToPounds, WeightUnit } from "components/format/Weight/Weight"
import { UnitSystem } from "components/UserPreferences/UserPreferencesContext"

export type UnitType = "kg" | "km" | "lbs" | "mi" | "%" | ""

export const Unit = ({ unit }: { unit: UnitType | "" }): React.JSX.Element | null => {
  switch (unit) {
    case "kg":
      return <WeightUnit />
    case "km":
      return <LengthUnit />
    default:
      return null
  }
}

export function convertUnit(unit: UnitType | string, unitSystem: UnitSystem): UnitType {
  if (unitSystem === UnitSystem.Metric) {
    return unit as UnitType
  }
  switch (unit) {
    case "kg":
      return "lbs"
    case "km":
      return "mi"
    default:
      return unit as UnitType
  }
}

export function convertUnitType(unit: UnitType, value: number): number {
  if (unit === "kg") {
    return kilogramsToPounds(value)
  }
  if (unit === "km") {
    return kilometersToMiles(value)
  }
  return value
}
